//en.js中：
const en = {
  login: {
    //登录页英文
    logintitle: "The user login",
    platformTitle: "Smart early warning management platform",
    logbtn: "login",
    rememberPassword: "Remember the password",

  },
  homepage: {
    //首页英文
    homeTitle:"Smart early warning management platform",
    welcomeTitle:"welcome",
    LoggedOut:"Logged out",
    ChangePassword:"Change the password",
    dashBoard:"dash board",
    OverviewSites:"Overview of monitoring sites",
    EnergyMonitoring:"Energy monitoring",
    alarmCenter:"alarm center",
    HistoricalEvents:"Historical events",
    environmentalEvents:"environmental events",
    readParam:"read param",
    MonitoringManagement:"Monitoring management",
    safetyReport:"safety report",
    dataCenter:"data center",
    MonitoringList:"Monitoring point list",
    DeviceManagement:"Device management",
    DeviceInformation:"Device Information",
    equipmentOperational:"service management",
    SystemManagement:"System management",
    OrganizationManagement:"Organization management",
    UserManagement:"User management",
    RoleManagement:"Role management",
    LabelManagement:"Label management",
    RiskManagement:"Risk management",
    CloseAll:"Close all",
    CloseTags:"Close other tags",
  },
  mappage:{
    //地图页英文
    monitoringSites:"Overview of monitoring sites",
    NewEquipment:"New equipment",
    NormalOperation:"Normal operation",
    EarlyHiddendanger:"Early hidden danger",
    MediumHiddendanger:"Medium term hidden danger",
    OperationalHazards:"Operational hazards",
    PotentiaElectricshock:"Potential electric shock of equipment",
    SeriousHiddendanger:"Serious hidden danger of equipment",
    InferiorEquipment:"Inferior electrical equipment",
    PotentialElectricshock:"Potential electric shock of equipment",
    ZeroGroundhybridconnection:"Zero ground hybrid connection",
    NonstandardWiring:"Nonstandard wiring",
    LineAging:"Line aging",
    ExcessiveContactresistance:"Excessive contact resistance",
    UnitDistributiondetails:"Unit distribution and details",
    NameMeasuringpoint:"Name of point",
    runningState :"running state ",
    tableDetail :"detail",
    operation :"operation",
    StartEndTime :"Start and end time",
    SelectStartTime :" Select start time",
    SelectEndTime :" Select end time",
    query :" query",
    lastYear :" last year",
    thisYear :" this year",
    HiddenDangertrend :"Hidden danger trend",
    AccessIncrement :"Access increment",
    UnitScore :"Unit hidden danger rectification score",
  },
  historyevent:{
    //历史事件页面英文
    DisposalStatus:"Disposal status",
    EventName:"Event name",
    NameMonitoringpoint:"Name of monitoring point",
    loading:"loading",
    QueryResults:"Query results",
    AllEvents:"All events",
    Completed:"Completed",
    incomplete:"incomplete",
    AlarmValue:"Alarm value",
    startTime:"start time",
    EventStatus:"Event status",
    HandlingOpinions:"Handling opinions",
    Reasondescribe:"Reason to describe",
    handle:"handle",
    revise:"revise",
    eventProcessing :"event processing ",
    AlarmReason :"Alarm reason",
    ThresholdFeedback :"Threshold feedback",
    reasonable :"reasonable",
    unreasonable :"unreasonable",
    confirm :"confirm",
    cancel :"cancel",
    Hasdisposal :"Completed",
    Notdisposed :"Incompleted",
    Processingopinion :"Processing opinion",
  },
  powerpage:{
    //能耗页面英文
    EnergyStatistics:"Energy  statistics",
    today:"today",
    ThisMonth:"This month",
    annual:"annual",
    CurrentElectricityconsumption:"Current period",
    ElectricityConsumptionperiod:"Last period",
    Proportionmonthlyelectricity:"Proportion of monthly electricity",
    LastMonth:"Last month",
    MonthlyValuecomparison:"Energy consumption / output value comparison",
    TotalEnergyconsumption:"Total energy consumption",
    TotalOutputvalue:"Total output value",
    TotalOutput:"Total output",
    piece:"piece",
    Rankingvaluepoints:"Output value ranking",
    OutputRankingpoints:"output ranking",
  },
  stationListpage:{
    //监测点列表英文
    inputstationname:"please input Name of monitoring point",
    editType:"edit type",
    NewPoints:"New points",
    all:"all",
    DeviceID:"Device ID",
    LoopID:"Loop ID",
    signalIntensity:"signal intensity ",
    edit:"edit",
    delete:"delete",
    allpick:"all pick",
    select:"selected",
    personCharge:"person in charge",
    contactInformation:"contact information",
    positionInformation:"position information",
    AffiliatedUnit:"Affiliated unit",
    equipment:"equipment",
    loop:"loop",
    save:"save",
    ClassificationPositions:"Classification of positions",
    AddClassification:"Add classification",
    ToBeclassified:"To be classified",
    classification:"classification",
    addtype:"addtype",
    groupName:"group name",
  },
  savereportList:{
    //安全报告列表英文
    reportModel:"report model",
    reportTime:"report time",
    reset:"reset",
    securityReportlist:"security report list",
    reportId:"reportId",
    reportName:"report name",
    generationTime:"generation time",
    review:"review",
    position:"addr485",

  },
  savereportDetail:{
    //安全报告详情英文
    reportExport:"report export",
    OverallEvaluation:"Overall evaluation",
    YourOverallsafety:"Your overall safety situation is",
    ThisWeek:"This week",
    ThisMonth:"This month",
    DailyScoring:"Daily scoring",
    DailyhiddendangerDistribution:"Daily hidden danger distribution",
    YourRectificationscore:"Your rectification status score is",
    PercentagemonitoringPoints:"Percentage of rectification scores at monitoring points",
    up:"up",
    down:"down",
    ProportionnotRectified:"Proportion of hidden dangers not rectified",
    HiddenDangerdiagnosis:"Hidden danger diagnosis",
    hiddenDangers:"hidden dangers is",
    includingMajorrisks:"including major risks",
    includingMajorrisksstation:"including major risks monitoring points",
    includinglargerisksstation:"including  large risks monitoring points",
    largeRisks:"large risks",
    mostHiddendangers:"have most hidden dangers is",
    hiddenDangershave:" hidden dangers",
    alarmeventnumber:" Your alarm event has",
    PleaseHandling:" Please pay attention to handling",
    AlarmDiagnosis:" Alarm diagnosis",
    NoHiddendanger:" No hidden danger",
    findRisk:" Find risk",
    DiagnosisConclusion:"Diagnosis conclusion",
    diagnosis:"diagnosis",
    monitoringpoints:"monitoring points",
    find:"",
    risk:"risks",
    alarms:"alarms",
    rectificationmonitoringpoints:" hidden dangers rectification at the monitoring points",
    including:"including",
    majorRisks:"major risks",
    deatilmain:"major hidden dangers that have not been rectified and need to be investigated, as shown in the table below:",
    HiddendangerLevel:"Hidden danger level",
    Hiddendangername:"Hidden danger name",
    Occurrencemonitoringpoint:"Occurrence monitoring point",
    Hiddendangerreportingtime:"Hidden danger reporting time",
  },
  numcenterPage:{
    //数据中心监测点英文
    realtimedata:"real time data",
    freezeData:"freeze data",
    hour:"hour",
    day:"day",
    month:"month",
    queryTime:"query time",
    Pushtheconfiguration:"Push the configuration",
    selectYear:"select year",
    selectMonth:"select month",
    Selecwarm:"select warm",
    selectDay:"select day",
    chart:"chart",
    data:"data",
    export:"export",
    other:"other",
    manager:"manager",
    telephone:"phone",
  },
  equipmentListPage:{
    //设备信息列表页中文
    deviceModel:"device model",
    enableState:"enable state",
    enable:"enable",
    deactivate:"deactivate",
    connectState:"connect state",
    onlineState:"online state",
    online:"online",
    offline:"offline",
    deviceName:"device name",
    inputDevicename:"input device name",
    deviceImei:"device imei",
    inputdeviceImei:"input device imei",
    addHost:"add host",
    batchDelete:"batch delete",
    batchGeneration:"batch generation",
    onlineDevice:"online device",
    offlineDevice:"offline device",
    UploadHost:"Upload host",
    downloadHosttemplate:"download host template",
    uploadSlave:"upload slave",
    downloadSlavetemplate:"download slave template",
    circusNumber:"circus number",
    circusModel:"circus model",
    startStop:"start stop",
    connectStatus:"connect status",
    unconnect:"unconnect",
    connected:"connected",
    ProtocolType:"Protocol type",
    updateTime:"update time",
    viewDevice:"view device",
    viewCircle:"view circle",
    externalDevices:"external devices",
    addSlave:"add slave",
    giveAddress:"give address",
    simNumber:"sim number",
    remark:"remark",
    uploadImage:"upload image",
    terminalName:"terminal name",
    communicationAddress:"communication address",
    CircleName:"circle name",
    status:"status",
    normal:"normal",
    malfunction:"malfunction",
    EditCircle:"edit circle",
    SelectMonitoring:"select monitoring",
    AddMonitoring:"add monitoring",
    ReviewImages:"review images",
    MassProduction:"Mass production",
    ManuallyAdd:"Manually add",
    restart:"restart",
    getdata:"getdata",
    ObtainingRealtimeparameters:"Obtaining real-time parameters",
    GetsfreezingParametersathour:"Gets freezing parameters at hour",
    GetsfreezingParametersatday:"Gets freezing parameters at day",
    GetsfreezingParametersatmonth:"Gets freezing parameters at month",
    ObtainingDeviceParameters:"Obtaining Device Parameters",
    SetTheparameters:"Set the parameters",
    DownloadTheframe:"Download the frame",
    ConnectedOffline:"Connected Offline",
    ConnectionOnline:"Connection Online",
    Theserialnumber:"The serial number",
    parameterName:"parameter name",
    parameterValue:"parameter value",
    Setthethreshold:"Set the threshold",
    Insulationaginglevel:"Insulation aging level 1",
    Insulationaginglevel2:"Insulation aging level 2",
    Insulationaginglevel3:"Insulation aging level 3",
    Electricalfirelevel1:"Electrical fire level 1",
    CheckCircuit:"Check the circuit",
    RunningState:"Running state",
    ThresholdConfiguration:"Threshold configuration",
    chooseTime:"choose time",
    EditParameters:"Edit parameters",
    hostMachineimei:"host machine imei",
    frameData:"frame data",
    directionType:"direction type",
    location:"location",
  },
  systemPage:{
    //系统管理英文页
    OrganizationalStructure:"Organizational structure",
    newOrganization:"add",
    DeleteTheorganization:"Delete",
    OrganizeInformation:"Organize information",
    EditTheinformation:"Edit the information",
    ConfirmTosubmit:"Confirm to submit",
    Weeklyreport:"Weekly report",
    Monthlyreport:"Monthly report",
    superiorOrganization:"superior organization",
    OrganizationName:"Organization name",
    longitude:"longitude",
    latitude:"latitude",
    unitLabel:"unit label",
    PleaseSelect:"Please select",
    add:"add",
    OrganizationDescriptions:"Organization descriptions",
    userInformation:"user information",
    userName:"user name",
    AccountStatus:"Account status",
    OrganizationalHierarchy:"Organizational hierarchy",
    Newusers:"New users",
    user:"user",
    plaseInput:"plase input",
    organization:"organization",
    role:"role",
    UserLabel:"User label",
    ModifyThetime:"Modify the time",
    password:"password",
    roleList:"role list",
    newRole:"new role",
    roleName:"role name",
    RoleOfnote:"Role of note",
    menuPermission:"menu permission",
    roleDescribe:"role describe",
    LabelTypeManagement:"Label Type Management",
    LabelManagement:"Label management",
    newLabels:"new labels",
    labelsId:"labelsId",
    labelType:"label type",
    labelName:"label name",
    addLabeltype:"add label type",
    addTime:"add time",
    hiddenDangerlevel:"hidden danger level",
    hiddenDangertype:"hidden danger type",
    HiddenDangerlist:"Hidden danger list",
  },
  allitem:{
    //一些通用的词条英文
    ConfirmtheDeletion:"Confirm the deletion?",
    SubmittedSuccessfully:"Submitted successfully",
    submitFailure:"submit failure",
    HandleAsuccessful:"Handle a successful",
    dealwithfailure:"deal with failure",
    determine:"determine",
    Deletedsuccessfully:"Deleted successfully",
    DeleteFailed:"Delete failed",
    SuccessfullyChanged:"Successfully changed",
    Failuretomodify:"Failure to modify",
    addsuccess:"Add success",
    AddFailure:"Add failure",
    PleaseDepartmentfirst:"Please select the department first",
    Uploadedsuccessfully:"Uploaded successfully",
    Uploadfailed:"Uploaded failed",
    hosttemplate:"host template",
    machinetemplate:"machine template",
    Modifysuccess:"Modify the success",
  },
  stationdetail:{
    //监测点详情页面英文
    details:"details",
    HiddenDangerhistory:"Hidden danger history",
    Getreatimedata:"Get real-time data",
    ComprehensiveMonitoring:"Comprehensive monitoring",
    SafetyMonitoring:"Safety monitoring",
    Monitorsitesafetydata:"Monitor site safety data",
    ResidualCurrent:"Residual current",
    temperature:"temperature",
    ElectricalFirerisk:"Electrical fire risk",
    InsulationAgingrisk:"Insulation aging risk",
    savety:"save",
    early:"early",
    medium:"medium",
    dangerous:"dangerous",
    voltage:"voltage",
    current:"current",
    HarmonicCurrent:"Harmonic current",
    ActivePower:"Active power",
    powerFactor:"power factor",
    APhase:"A phase",
    BPhase:"B phase",
    CPhase:"C phase",
    RiskIndicators:"Risk indicators",
    WeeksData:"Weeks data",
    currentData:"current data",
    ElectricityConsumptionstatistics:"Electricity consumption statistics",
    AlarmEventstatistics:"Alarm event statistics",
    EnergyConsumptionmonitoring:"Energy consumption monitoring",
    Ratioofelectricityconsumptiontoday:"Ratio of electricity consumption today",
    Electricitytoday:"Electricity consumption at the monitoring site today / Unit electricity consumption today",
    yesterday:"yesterday",
    sequential:"sequential",
    TotalEnergyconsumptionyesterday:"Total energy consumption yesterday",
    thedaybeforeyesterday:"the day before yesterday",
    EnergyConsumptionofthismonth:"Energy consumption of this month",
    powerQuality:"power quality",
    HiddenTroubledisposal:"Hidden trouble disposal",
    disposalofhistory:"disposal of history",
    monthsData:"months data",
    dayData:"day data",
    yearData:"year data",
    EnergyconsumptionTrendStatistics:"Energy consumption Trend Statistics",
    ProductionConfiguration:"Production configuration",
    DownloadTemplate:"Download the template",
    UploadData:"Upload data",
    ExportData:"Export data",
    VoltageHarmonic:"Voltage harmonic",
    CurrentHarmonic:"Current harmonic",
    Reactivepower:"Reactive power",
    Feedervoltage:"Feeder voltage",
    loadCurrent:"load current",
    FundamentalWavecurrent:"Fundamental wave current",
    ResidualFundamentalcurrent:"Residual fundamental current",
    Residualharmoniccurrent:"Residual harmonic current",
    Insulationresistance:"Insulation resistance",
    MessageManagement:"SMS management",
    Selecthiddentrouble:"Select hidden trouble",
    loadpower:"load power",
    LoadPowerfactor:"Load power factor",
    Loadreactivepower:"Load reactive power",
    remainingPower:"remaining power",
    electricity:"electricity",
    frequency:"frequency",
    nodata:"no data",
    fundamentalWavepower:"fundamental wave power",
    Apparentpower:"Apparent power",
    ActiveElectricaldegrees:"Active electrical degrees",
    HiddendangerHistory:"Hidden danger History",
    rectificationstatus:"rectification status",
    Reporttime:"Report time",
    IssuedSuccessful:"Issued by the successful",
    newequipment:"new equipment",
    Editequipment:"Edit equipment",
    deletesure:"sure to delete?",
    Editthehost:"Edit the host",
    Editmachine:"Edit the machine",
    movedslavemachine:"When a host is moved, the slave machine is moved",
    newhost:"new host",
    Lookhost:"Look at the host",
    Lookslave:"Look at the slave",
   timeirst:"Please select the time first",
    Sendingsucceeded:"Sending the request succeeded",
    Failedsend:"Failed to send the request",
    Sendingquerysucceeded:"Sending the query request succeeded",
    querysuccessful:"query succeeded",
    Sendingrequestsucceeded:"Sending a restart request succeeded",
    Onlyonelabel:"Only one label of the same type can be selected",
    Edittheuser:"Edit the user",
    Editingtherole:"Editing the role",
    Editlabeltype:"Edit label type",
    Editlabel:"Edit label",
    Pleaseenternumber:"Please enter your account number",
    Pleaseenteryourpassword:"Please enter your password",
    Devicecontrol:"Device control",
    breakbrake:"break-brake",
    closing:"closing",
  }




}

export default en;
